import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton } from '@/components';
import EventsTable from './EventsTable';
import HistoricGraph from './HistoricGraph';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';

export default function SealStabilityFeePage() {
  const ilk = 'LSE-MKR-A';
  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/parameters/stability-fee/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Flex gap="3xs" alignItems="center">
            <EntityName symbol1={<CryptoIcon name={'MKR'} size="5" />}>
              <Flex gap="m" flexDirection="column">
                <Flex gap="3xs">
                  <Heading size="1">{data.name} Stability Fee</Heading>
                </Flex>
              </Flex>
            </EntityName>
          </Flex>
        }>
        <>
          <HistoricGraph ilk={ilk} />
          <EventsTable ilk={ilk} />
        </>
      </Page>
    );
  }

  return <PageSkeleton />;
}
